// Subdomain redirect logic
document.addEventListener('DOMContentLoaded', function () {
	var locationWrappers = document.getElementsByClassName(
		'location-switcher-list'
	);
	var locationList = document.getElementById('location-list');

	Array.prototype.forEach.call(locationWrappers, function (el) {
		el.addEventListener('click', function (e) {
			showList(e);
		});

		el.addEventListener('keypress', function (e) {
			// if(e.which == 13) {
			showList(e);
			// }
		});
	});

	function showList(event) {
		let el = event.target.parentElement.parentElement;
		locationList = el.querySelector('#location-list');

		if (locationList.classList.contains('hidden')) {
			locationList.classList.remove('hidden');
		} else {
			locationList.classList.add('hidden');
		}
	}

	// document.addEventListener('click', function (event) {
	//
	// 	// If the clicked element isn't a data-locale element
	// 	if (!event.target.matches('[data-locale]')) return;
	//
	// 	//add the hidden class to the grandparent
	// 	event.target.parentNode.parentNode.classList.add('hidden');
	//
	// 	event.preventDefault();
	// 	// document.cookie = 'locale=' + event.target.getAttribute('data-locale') + '; max-age=31536000; path=/;';
	// 	location.reload();
	// });
});
